import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as UserIcon } from 'icons/user.svg';
import { ReactComponent as CaseIcon } from 'icons/briefcase.svg';
import { ReactComponent as OrdersIcon } from 'icons/orders.svg';
import ROUTES from 'constants/routes';
import styles from './SidebarMenu.module.scss';

interface MenuItem {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>,
  label: ReactNode,
  key: string,
}

const menuItems: MenuItem[] = [
  { Icon: UserIcon, label: 'Профиль', key: ROUTES.HOME },
  { Icon: CaseIcon, label: 'Договоры', key: ROUTES.CONTRACTS },
  { Icon: OrdersIcon, label: 'Заявки', key: ROUTES.ORDERS },
];

const SidebarMenu: React.FC = () => {
  return (
    <div className={styles.menu}>
      {menuItems.map(({ Icon, label, key }) => (
        <NavLink
          key={key}
          to={key}
          className={({ isActive }) => isActive ? styles.activeMenuItem : styles.menuItem}
        >
          <Icon />
          <span className={styles.menuItemText}>{label}</span>
        </NavLink>
      ))}
    </div>
  );
};

export default SidebarMenu;
